<div *hasPermissions="appDescription.permission" class="app-launcher-app">
  <div
    class="main-link h-[60px] box-content relative flex flex-row p-4 pr-3 justify-start items-center"
    (click)="openApp()">
    <div class="mr-4 flex justify-center items-center">
      @if (appDescription.icon && appDescription.icon.iconId) {
        <claas-icon
          [iconId]="appDescription.icon.iconId"
          [iconName]="appDescription.icon.iconName"
          [namespace]="appDescription.icon.namespace ?? ''"
          [size]="appDescription.icon.size ?? 48"
          [iconStyle]="appDescription.icon.style ?? 'bold'">
        </claas-icon>
      } @else {
        <img [src]="appDescription.iconImg" data-testid="app-image" />
      }
    </div>

    <div class="flex flex-col">
      <span class="heading-h6 app-name !mb-0" data-testid="app-name">
        {{ appDescription.name | translate }}
      </span>

      <div class="mat-body-2 app-description" data-testid="app-description">
        {{ appDescription.description | translate }}
      </div>
    </div>

    @if (appDescription.outsideLink) {
      <claas-icon class="outside-link" iconId="747620" namespace="cc" [size]="20"> </claas-icon>
    }
    @if (appDescription.newTabLink) {
      <claas-icon [removeDefaultColor]="true" class="new-tab-link" iconId="659469" namespace="cc" [size]="16">
      </claas-icon>
    }
  </div>

  @if (appDescription.appLauncerFastAccess) {
    <!-- Fast Access -->
    <div class="flex flex-col mt-2">
      <span class="quick-start-title subtitle-1 mx-4" data-testid="quick-access-menu-title">
        {{ 'navbar.app-launcher.quick_start' | translate }}
      </span>

      <div class="py-2">
        <!-- Fast Access entries -->
        @for (fastAccessDescription of appDescription.appLauncerFastAccess; track fastAccessDescription) {
          <app-app-launcher-fast-access-entry
            [fastAccessDescription]="fastAccessDescription"
            [attr.data-testid]="fastAccessDescription.testId">
          </app-app-launcher-fast-access-entry>
        }
      </div>
    </div>
  }
</div>
